<template>
    <div class="home">
        <div class="container">
            <div class="columns is-centered">
                <div class="column">
                        <ValidationObserver v-slot="{ errors }" tag="div">
                            <input-form
                            ref="form"
                            :errors="errors"
                            name="ChildInfo"
                            @submit.prevent="nextPage"
                            >
                                <div class="content">
                                    <br>
                                    <callout type="warning">
                                        <b>Please skip this section if you have no children under the age of 18.</b>
                                    </callout>
                                    <h1>Children (Under 18)</h1>
                                    <h6>Please fill out the chart below with the names and birth dates of any individuals living in the unit who are not listed on lease:</h6>

                                    <div class="object-border child-information">
                                        <div
                                        v-for="child in FullApplication.ChildList"
                                        :key="child.id"
                                        :class="`child-contact-information-${child.id}`"
                                        >
                                        <div>
                                            <div v-if="child.id > 1">
                                            </div>
                                            <h3>Child (under 18) - {{ child.id }}</h3>
                                            <div
                                            class="columns"
                                            >
                                            <div class="column">
                                                <vee-textbox
                                                v-model="child.FirstName"
                                                mode="eager"
                                                :name="`txt-child-${child.id}-first-name`"
                                                placeholder="First Name"
                                                rules="required"
                                                required
                                                error="This field is required"
                                                />
                                            </div>
                                            <div class="column">
                                                <vee-textbox
                                                v-model="child.LastName"
                                                mode="eager"
                                                :name="`txt-child-${child.id}-last-name`"
                                                placeholder="Last Name"
                                                rules="required"
                                                required
                                                error="This field is required"
                                                />
                                            </div>
                                            </div>
                                            <div class="columns">
                                            <div class="column">
                                                <vee-textbox
                                                v-model="child.DateOfBirth"
                                                :name="`text-child-${child.id}-date-of-birth`"
                                                label="Date of Birth"
                                                rules="required"
                                                required
                                                placeholder="Date of Birth"
                                                type="date"
                                                />
                                            </div>
                                            </div>
                                            <button
                                                type="button"
                                                class="button is-danger is-secondary"
                                                @click="removeChild(child.id, FullApplication.ChildList)"
                                            >
                                                <i class="fa fa-solid fa-trash"></i>
                                            </button>
                                            <br>

                                            </div>
                                        </div>
                                        <div v-if="FullApplication.ChildList.length >= 1">
                                            <br>
                                        </div>
                                            <button
                                                type="button"
                                                class="button is-success is-secondary"
                                                :disabled="SubmitStatus.Value == SubmitStatus.Options.PENDING"
                                                @click="addChild(FullApplication.ChildList.length)"
                                            >
                                                <i class="fa fa-solid fa-plus"></i>
                                            </button>
                                        </div>
                                        <br>
                                </div>
                                <template #submit>  
                                    <div class="actions columns">
                                        <div class="column" style="text-align: start;">
                                            <button
                                                type="button"
                                                class="button is-primary"
                                                @click="previousSection"
                                            >
                                            <i class="fa fa-solid fa-arrow-left" style="font-size: x-large;"></i>
                                            </button>
                                        </div>
                                        <div class="column" style="text-align: end;">
                                            <button
                                                type="button"
                                                class="button is-primary"
                                                @click="nextSection"
                                            >
                                            <i class="fa fa-solid fa-arrow-right" style="font-size: x-large;"></i>
                                            </button>
                                        </div>   
                                    </div>
                                </template>
                            </input-form>
                        </ValidationObserver>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import options from "@/utilities/options";
//import * as incomeFunctions from "@/utilities/object-functions";
import Child from "@/utilities/classes/child";

export default {
  name: 'ChildInfo',
  mixins: [options],
  data(){
    return{
        FullApplication: null,
    }
  },
 async mounted(){
    window.scrollTo(0, 0);
    this.FullApplication = await this.$vlf.getItem('fullApplication');

    // this.TenantArray = this.FullApplication.TenantList;
    // this.IncomeArray = this.TenantArray.Incomes;
    // this.TaxesArray = this.TenantArray.GrossTaxes;
    
    // if(this.FullApplication.ChildList.length < this.childId){
    //     incomeFunctions.addChild(this.childId - 1, this.FullApplication.ChildList);
    // }
  },
  methods: {
    async previousSection(){
        const isInputValid = await this.$refs.form.$parent.validate();
          if (isInputValid) {
            this.$vlf.removeItem('fullApplication');
            await this.$vlf.setItem('fullApplication', this.FullApplication);
            this.$router.push({
                name: "TenantIncome",
                params: { tenantId: this.FullApplication.TenantList.length  },
            });
        }
    },
    async nextSection(){
        const isInputValid = await this.$refs.form.$parent.validate();
        if (isInputValid) {
            this.$vlf.removeItem('fullApplication');
            await this.$vlf.setItem('fullApplication', this.FullApplication);
            this.$router.push({
                name: "ConfirmationPage",
            });
        }
    },
    async addChild(childId){
        const isInputValid = await this.$refs.form.$parent.validate();
          if (isInputValid) {
          this.SubmitStatus.Value = this.SubmitStatus.Options.PENDING;
            this.$vlf.removeItem('fullApplication');
            await this.$vlf.setItem('fullApplication', this.FullApplication);

        const child = new Child(Number(childId) + 1);
        this.FullApplication.ChildList.push(child);
        }
        this.SubmitStatus.Value = this.SubmitStatus.Options.OK;
    },
    async removeChild(childId, childArray){
        
            childArray.splice(childId - 1, 1);

            for(var i = childId  - 1; i < childArray.length; i++){
                childArray[i].id = childArray[i].id - 1;
            }
            this.$vlf.removeItem('fullApplication');
            await this.$vlf.setItem('fullApplication', this.FullApplication);
        
    },
  }
}
</script>

<style>
.object-border{
    border-width: 5px;
    border-style: solid;
    padding: 1%;
    border-radius: 10px;
    border-color: #0f4d90;
}
</style>